/* eslint-disable @next/next/no-img-element */
'use client';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import Button from '../ui/Button';
import { useGetFinancings } from '@/actions/financing';


export default function Financing() {
    const { financings, financingsLoading, financingsEmpty } = useGetFinancings();

    if (financingsEmpty) {
        return null;
    }

    return (
        <section className="py-10 sm:py-15 md:px-5 overflow-hidden">
            <div className="max-w-326.5 mx-auto w-full">
                <div className="text-center mb-10 sm:mb-12 md:mb-18.75 md:px-0 px-4">
                    <h2 className="text-center font-red-hat text-[#1B365E] text-[30px] md:text-[40px] font-light leading-10 md:leading-13.25 tracking-[0.2px]">
                        Les Financements
                    </h2>

                    <p className="max-w-267 mx-auto mt-6 md:mt-11.25 text-[#1B365E] text-[18px] md:text-[20px] text-center leading-5 md:leading-7.5 tracking-[0.3px] font-medium">
                        Prise en charge de votre formation grâce aux dispositifs d’aide au financement d’une formation professionnelle,
                        adaptés à différentes situations. Optimisez le financement de votre formation selon votre contexte.
                    </p>
                </div>

                {/* Carousel */}
                <div className="relative">
                    <Swiper
                        modules={[Navigation, Pagination]}
                        spaceBetween={34}
                        navigation={{
                            prevEl: '.financing-prev',
                            nextEl: '.financing-next',
                        }}
                        pagination={{ clickable: true }}
                        breakpoints={{
                            0: {
                                slidesPerView: "auto",
                                spaceBetween: 34,
                                pagination: { enabled: true },
                            },
                            1280: {
                                slidesPerView: 5,
                                spaceBetween: 34,
                                pagination: { enabled: false }
                            },
                        }}
                        className="financing-swiper w-full ms-0! !pb-10 !px-4"
                    >
                        {financingsLoading
                            ? Array.from({ length: 5 }).map((_, i) => (
                                <SwiperSlide key={i} className="!w-[223px] xl:!w-auto">
                                    <div className="bg-white rounded-lg border border-[#ABABAB] px-5 pt-4 pb-[19px] w-full h-full min-h-[320px] animate-pulse" />
                                </SwiperSlide>
                            ))
                            : financings.map((option) => {
                                const cardContent = (
                                    <>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8ZM4.75 7.25C4.33579 7.25 4 7.58579 4 8C4 8.41421 4.33579 8.75 4.75 8.75L9.43934 8.75L8.21967 9.96967C7.92678 10.2626 7.92678 10.7374 8.21967 11.0303C8.51256 11.3232 8.98744 11.3232 9.28033 11.0303L11.7803 8.53033C12.0732 8.23744 12.0732 7.76256 11.7803 7.46967L9.28033 4.96967C8.98744 4.67678 8.51256 4.67678 8.21967 4.96967C7.92678 5.26256 7.92678 5.73744 8.21967 6.03033L9.43934 7.25L4.75 7.25Z" fill="#1B365E" />
                                        </svg>
                                        {option.buttonText}
                                    </>
                                );

                                return (
                                    <SwiperSlide key={option.id} className="">
                                        <div className="!w-[223px] xl:!w-auto  bg-white rounded-lg border border-[#ABABAB] px-5 pt-4 pb-[19px] w-full flex flex-col h-full min-h-[320px] transition-shadow">
                                            <div className="">
                                                <div className="">
                                                    <h3 className="text-[16px] leading-6.5 tracking-[0.2px] font-bold text-[#1B365E] mb-1">
                                                        {option.title}
                                                    </h3>
                                                    {option.subtitle && (
                                                        <p className="text-[12px] leading-5 tracking-[0.2px] font-normal text-[#1B365E]">
                                                            {option.subtitle}
                                                        </p>
                                                    )}
                                                </div>

                                                {option.logo && (
                                                    <div className="flex items-center mb-1 h-15.25">
                                                        <img
                                                            width={123}
                                                            height={61}
                                                            src={option.logo}
                                                            alt={option.title}
                                                            loading="lazy"
                                                            className="w-30.75 max-w-full max-h-full object-contain object-left"
                                                            onError={(event) => {
                                                                event.currentTarget.style.display = 'none';
                                                            }}
                                                        />
                                                    </div>
                                                )}

                                                {option.description && (
                                                    <p className="text-[12px] leading-5 tracking-[0.2px] font-normal text-[#1D1D1D] border-b border-[#D9D9D9] pb-3">
                                                        {option.description}
                                                    </p>
                                                )}
                                            </div>

                                            {option.buttonUrl ? (
                                                <a
                                                    href={option.buttonUrl}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="w-full cursor-pointer flex items-center justify-center gap-2 text-[14px] sm:text-[15px] text-[#1B365E] font-bold hover:opacity-80 transition-opacity mt-4"
                                                >
                                                    {cardContent}
                                                </a>
                                            ) : (
                                                <button className="w-full cursor-pointer flex items-center justify-center gap-2 text-[14px] sm:text-[15px] text-[#1B365E] font-bold hover:opacity-80 transition-opacity mt-4">
                                                    {cardContent}
                                                </button>
                                            )}
                                        </div>
                                    </SwiperSlide>
                                );
                            })}
                    </Swiper>

                    {/* Desktop */}
                    <div className='hidden lg:flex lg:absolute lg:-right-12 lg:top-7 flex-row lg:flex-col gap-4 md:gap-5 justify-center lg:justify-start mt-6 lg:mt-0 z-20'>
                        <button className="financing-next swiper-button-next !static !mt-0 !w-auto !h-auto flex items-center justify-center cursor-pointer outline-none after:hidden group">
                            <svg width="28" height="30" viewBox="0 0 28 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M27.4142 16.1408C28.1953 15.3597 28.1953 14.0934 27.4142 13.3123L14.6863 0.584427C13.9052 -0.196622 12.6389 -0.196622 11.8579 0.584427C11.0768 1.36548 11.0768 2.63181 11.8579 3.41285L23.1716 14.7266L11.8579 26.0403C11.0768 26.8213 11.0768 28.0876 11.8579 28.8687C12.6389 29.6497 13.9052 29.6497 14.6863 28.8687L27.4142 16.1408ZM0 16.7266H26V12.7266H0V16.7266Z" fill="currentColor" />
                            </svg>
                        </button>

                        <button className="financing-prev swiper-button-prev !static !mt-0 !w-auto !h-auto flex items-center justify-center cursor-pointer outline-none after:hidden group">
                            <svg width="28" className='rotate-180' height="30" viewBox="0 0 28 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M27.4142 16.1408C28.1953 15.3597 28.1953 14.0934 27.4142 13.3123L14.6863 0.584427C13.9052 -0.196622 12.6389 -0.196622 11.8579 0.584427C11.0768 1.36548 11.0768 2.63181 11.8579 3.41285L23.1716 14.7266L11.8579 26.0403C11.0768 26.8213 11.0768 28.0876 11.8579 28.8687C12.6389 29.6497 13.9052 29.6497 14.6863 28.8687L27.4142 16.1408ZM0 16.7266H26V12.7266H0V16.7266Z" fill="currentColor" />
                            </svg>
                        </button>
                    </div>
                </div>

                {/* CTA Button */}
                <div className="flex justify-center mt-6 md:mt-4 md:px-0 px-4">
                    <Button
                        variant="outline-gradient"
                        className='w-full sm:px-10! px-2! sm:w-fit'
                        onClick={() => {
                            console.log('Navigate to teaching application');
                        }}
                    >
                        En savoir plus sur les financements
                    </Button>
                </div>
            </div>

            <style jsx>{`
                :global(.financing-next),
                :global(.financing-prev) {
                    color: #1B365E;
                    transition: color 0.3s;
                }
                :global(.swiper-button-disabled) {
                    color: #ABABAB !important;
                    opacity: 1 !important;
                    cursor: not-allowed !important;
                }
                :global(.financing-swiper) {
                    padding-bottom: 0px !important;
                }
                :global(.financing-swiper .swiper-wrapper) {
                    display: flex !important;
                }
                :global(.financing-swiper .swiper-slide) {
                    height: auto !important;
                    display: flex !important;
                }
                @media (max-width: 1279px) {
                    :global(.financing-swiper .swiper-slide) {
                        width: auto !important;
                    }
                }
                .swiper-button-prev::after,
                .swiper-button-next::after {
                    display: none;
                }
            `}</style>
        </section>
    );
}
